import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient, HttpClient } from '@angular/common/http';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorIntl } from '../paginator-intl/paginator-intl';
import { Shared } from '../shared/shared';
import { AppInterceptor } from './app.interceptor';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';

// Nota: los módulos de Angular Material ya NO se importan globalmente. Solo el pipeline de
// imágenes (Plan 02: product-image / dialog-image / dialog-image-upload) usa Material y cada
// componente standalone importa sus propios módulos. Se conserva BrowserAnimationsModule
// (animaciones que aún usan esos componentes) y el provider MatPaginatorIntl (paginadores de imagen).
export const appConfig: ApplicationConfig =
{
  providers: [
    importProvidersFrom(BrowserModule,
      AppRoutingModule,
      BrowserAnimationsModule,
      FormsModule,
      ReactiveFormsModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })),
    Shared,
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
    { provide: MatPaginatorIntl, useClass: PaginatorIntl },
    provideHttpClient(withInterceptorsFromDi())
  ]
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
